export default __webpack_public_path__ + "static/media/avatar.1f03d958.jpg";